export default "__VITE_PUBLIC_ASSET__e7861a35__"